const initialState = {
  user: null,
  isLoggingOut: false,
  isUpdatingPreferences: false,
  clients: [],
};

export default initialState;
